import React from 'react'
import {Icon} from '@chakra-ui/react'

const TickCircleEmptyIcon = (props) => {
    return (
        <Icon viewBox="0 0 12 12" fill="none" data-testid="tick-circle-empty-icon" {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
            >
                <g clipPath="url(#clip0_5960_16469)">
                    <path
                        d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeDasharray="1 2"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_5960_16469">
                        <rect width="12" height="12" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </Icon>
    )
}

export default TickCircleEmptyIcon
